import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { PARTNERS } from "@/data/content";
import Intro from "@/components/site/Intro";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Challenge from "@/components/site/Challenge";
import Solution from "@/components/site/Solution";
import Difference from "@/components/site/Difference";
import Flow from "@/components/site/Flow";
import Lifecycle from "@/components/site/Lifecycle";
import Dashboard from "@/components/site/Dashboard";
import Industries from "@/components/site/Industries";
import ValueProp from "@/components/site/ValueProp";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  const [intro, setIntro] = useState(true);
  const closeIntro = useCallback(() => setIntro(false), []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (intro) {
      window.__lenis?.stop();
      document.body.style.overflow = "hidden";
    } else {
      window.__lenis?.start();
      document.body.style.overflow = "";
    }
  }, [intro]);

  return (
    <div className="App bg-ink font-sans text-[#F4F5F7] antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1D1811", border: "1px solid rgba(197,160,89,0.35)", color: "#F4F5F7" } }} />
      <AnimatePresence>{intro && <Intro onDone={closeIntro} />}</AnimatePresence>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Challenge />
        <Solution />
        <Difference />
        <Flow />
        <Lifecycle />
        <Dashboard />
        <Industries />
        <ValueProp />
        <About />
        <Contact />
      </main>
      <Footer />
      <a
        data-testid="floating-whatsapp-button"
        href={PARTNERS[0].whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with VERIVISTA on WhatsApp"
        className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full border border-gold/50 bg-elevated text-gold shadow-[0_12px_32px_rgba(0,0,0,0.5)] transition-all duration-300 hover:scale-105 hover:bg-gold hover:text-ink"
      >
        <MessageCircle size={22} strokeWidth={1.5} />
      </a>
    </div>
  );
}

export default App;
